// Styles
import './Checkbox.scss';
import React from "react";
import { ThemeContext } from "../theme/Theme";

interface CheckboxProps {
	name: string,
	value: string,
	checked: boolean,
	ariaDescription?: string,
	label: any,
	onChange: any,
	style?: any
}

function Checkbox(props: CheckboxProps) {
	const context = React.useContext(ThemeContext);
	const style: any = {
		selected: {},
		default: {},
		borderColor: context.themeManager.value(
			'form-element', 'borderColor', 'border-color-form-element')
	};
	const {
		name,
		value,
		onChange,
		checked,
		label,
	} = props;
	
	const randomId = parseInt(String(Math.random() * 100000), 10);
	
	return (
		<div className="checkbox__container" style={props.style}>
			<input
				className="checkbox__input"
				id={name + randomId}
				type="checkbox"
				name={name}
				value={value}
				checked={checked}
				onChange={onChange}
				style={style}
				{...(props.ariaDescription ? {'aria-description': props.ariaDescription} : {})}
			/>
			<label
				className="checkbox__label"
				htmlFor={name + randomId}
				style={checked ? style.checked : style.default}
			>{label}</label>
		</div>
	);
}

export default Checkbox;
